export default "__VITE_ASSET__ad33b071__"